import { Component, OnInit, ViewChild } from '@angular/core';
import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { UserService } from '../../../user/services/user.service';
import { User } from '../../../user/models/user.type';
import { SelectModule } from 'primeng/select';
import { Tabs, TabList, Tab, TabPanels, TabPanel } from 'primeng/tabs';
import { TaxonomyTab } from '../../../settings/model/taxonomy-tab';
import { ImportHistoryComponent } from '../import-history/import-history.component';
import { ImportFileComponent } from '../import-file/import-file.component';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { ShopService } from '../../../shop/service/shop.service';
import { Shop } from '../../../shop/types/shop.type';
import { FormsModule } from '@angular/forms';
import { NgxPermissionsService } from 'ngx-permissions';
import { LocalService } from '../../../../services/storage/local.service';
import { ImportService } from '../../service/import.service';
import { Util } from '../../../../utils/util';
import { DialogModule } from 'primeng/dialog';
import { ListboxModule } from 'primeng/listbox';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { Stepper, StepItem, Step, StepPanel } from 'primeng/stepper';
import { DatePickerModule } from 'primeng/datepicker';
import { SelectButtonModule } from 'primeng/selectbutton';
@Component({
  selector: 'app-catalog-import',
  standalone: true,
  imports: [
    TableModule,
    CardModule,
    TagModule,
    SelectModule,
    Tabs, TabList, Tab, TabPanels, TabPanel,
    CommonModule,
    ButtonModule,
    FormsModule,
    ImportHistoryComponent,
    ImportFileComponent,
    DialogModule,
    ListboxModule,
    TranslateModule,
    ProgressSpinnerModule,
    IconFieldModule,
    InputIconModule,
    ToggleButtonModule,
    Stepper, StepItem, Step, StepPanel,
    DatePickerModule,
    SelectButtonModule
  ],
  providers: [TranslateService],
  templateUrl: './catalog-import.component.html',
  styleUrl: './catalog-import.component.scss',
})
export class CatalogImportComponent implements OnInit {
  user: User;
  shops: any;
  filteredShops: any;
  selectedShop: Shop;
  selectedFilteredShop: Shop;
  selectedTabIndex: number = 0;
  isHistoryTabActive: boolean = false;
  previousShop: any;
  isOperator = false;
  aggregators = [];
  exportAggregatorStartDate: Date = undefined;
  exportAggregatorEndDate: Date = undefined;
  selectedAggregator;
  maxDate = new Date();
  minDate = new Date('01/01/1950');
  tabs: TaxonomyTab[] = [
    { label: 'importCatalog.import', componentTxt: 'import' },
    { label: 'importCatalog.history', componentTxt: 'history' },
  ];
  activeStep: number = 1;

  @ViewChild(ImportFileComponent) importFileComponent: ImportFileComponent;
  @ViewChild(ImportHistoryComponent)
  importHistoryComponent: ImportHistoryComponent;
  visible: boolean = false;
  selectedExportShop: Shop;
  exportShops: Shop[];
  currentPage = 0;
  hasNext = false;
  loading = false;
  hideImportModule = false;
  exportOptions: any[] = [{ label: 'Boutique', value: 'shop' }, { label: 'Agrégateur', value: 'aggregator' }];
  selectedExportOption: string = 'shop'
  constructor(
    private readonly userService: UserService,
    private readonly shopService: ShopService,
    private readonly localStore: LocalService,
    private readonly permissionService: NgxPermissionsService,
    private readonly importService: ImportService,
  ) {}

  ngOnInit(): void {
    const storedIndex = this.localStore.getItem('selectedImportTabIndex');
    if (storedIndex !== null) {
      this.selectedTabIndex = Number.parseInt(storedIndex, 10);
    }
    this.updateTabState();
    this.user = this.userService.getUser();
    if (this.user?.operator) {
      this.isOperator = true;
      if (this.isSuperAdmin()) {
        this.loadAllShops();
      } else if (
        this.permissionService.getPermission(
          'PERMISSION_IMPORT_OPERATOR_SELLER',
        )
      ) {
        this.shops = this.user.relatedShops.filter(
          (shop) => shop.shopCanImport,
        );
        this.hideImportModule = this.shops.length === 0;
        this.filteredShops = this.shops;
        this.initSelectedAndPreviousShop();
      }
      this.loadPaginatedShops('', 0);
      this.loadAggregators();
    } else {
      this.shops = this.user.relatedShops;
      this.filteredShops = this.user.relatedShops.filter(
        (shop) => shop.shopCanImport,
      );
      this.hideImportModule = this.filteredShops.length === 0;
      this.initSelectedAndPreviousShop();
    }
  }

  loadAggregators() {
    this.shopService.findAllAggregators().subscribe({
      next: (res: any[]) => {
        this.aggregators = res;
      },
    });
  }

  initSelectedAndPreviousShop() {
    const code = this.shopService.getSelectedShopCode();
    this.selectedShop = this.shops.find((shop) => shop.shopCode === code);
    this.selectedFilteredShop = this.filteredShops.find(
      (shop) => shop.shopCode === code,
    );
    if (
      this.selectedFilteredShop == undefined &&
      this.filteredShops.length > 0
    ) {
      this.selectedFilteredShop = this.filteredShops[0];
    }
    if (this.selectedShop == undefined && this.shops.length > 0) {
      this.selectedShop = this.shops[0];
    }
    this.previousShop = this.selectedShop;
  }

  onTabChange(value: any) {
    const tabIndex = typeof value === 'number' ? value : value?.index;
    this.selectedTabIndex = tabIndex;
    this.localStore.setItem('selectedImportTabIndex', tabIndex.toString());
    this.updateTabState();
  }

  loadAllShops(): void {
    this.shopService.getMarketplaceShops().subscribe({
      next: (res) => {
        this.shops = res.filter((shop) => shop.shopCanImport);
        this.hideImportModule = this.shops.length === 0;
        this.filteredShops = this.shops;
        this.initSelectedAndPreviousShop();
      },
    });
  }

  onShopChange(shop): void {
    if (shop != undefined && this.previousShop.shopCode != shop.shopCode) {
      this.shopService.setSelectedShopCode(shop.shopCode);
      this.importHistoryComponent?.onLazyLoad({
        first: 0,
        rows: this.importHistoryComponent?.rows,
        sortField: null,
        sortOrder: null,
      });
      this.importFileComponent?.loadHistory();
      this.previousShop = shop;
    }
  }
  updateTabState() {
    // Ensure `isHistoryTabActive` only changes when switching to history tab
    this.isHistoryTabActive =
      this.tabs[this.selectedTabIndex]?.componentTxt === 'history';
  }

  showExportDialog() {
    if (this.isOperator) {
      this.visible = true;
    } else {
      this.exportImportHistory();
    }
  }

  exportImportHistory() {
    let shopCode = '';
    let startDate = '';
    let endDate = '';
    this.loading = true;
    if (this.isOperator) {
      shopCode = this.selectedExportOption === 'aggregator'
        ? this.selectedAggregator.name
        : this.selectedExportShop.shopCode;
      startDate = this.exportAggregatorStartDate?.toLocaleString('fr-FR');
      endDate = this.exportAggregatorEndDate?.toLocaleString('fr-FR');
    } else {
      shopCode = this.previousShop.shopCode;
    }
    const data = {
      shopCode: shopCode,
      startDate: startDate,
      endDate: endDate,
    };
    this.importService.exportImportHistory(data).subscribe({
      next: (response) => {
        if (this.isOperator) {
          this.loading = false;
          this.closeExportModal();
        }
        Util.handleExportSuccess(response);
      },
      error: Util.handleExportError,
    });
  }

  onDateSelect(type: string, date) {
    if (type === 'start') {
      this.minDate = date;
    } else {
      this.maxDate = date;
    }
  }

  closeExportModal() {
    this.visible = false;
    this.selectedExportOption = 'shop'
    this.exportAggregatorStartDate = undefined;
    this.exportAggregatorEndDate = undefined;
    this.selectedAggregator = {};
    this.selectedExportShop = {};
    this.maxDate = new Date();
    this.minDate = new Date('01/01/1950');
  }

  nextPage(): void {
    if (this.hasNext) {
      this.currentPage++;
      this.loadPaginatedShops('', this.currentPage);
    }
  }

  previousPage(): void {
    if (this.currentPage > 0) {
      this.currentPage--;
      this.loadPaginatedShops('', this.currentPage);
    }
  }

  onFilter(event: any): void {
    const value = event.target.value;
    this.loadPaginatedShops(value, this.currentPage);
  }

  loadPaginatedShops(keyword: string, page: number) {
    this.loading = true;
    this.shopService.getPaginatedShops(keyword, page).subscribe({
      next: (res) => {
        this.exportShops = res['shops'];
        this.hasNext = res['hasNext'];
        this.loading = false;
      },
    });
  }

  isSuperAdmin() {
    return this.permissionService.getPermission('PERMISSION_SUPER_ADMIN');
  }
}
